var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory82(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 293,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 0,
    width: 307,
    height: 293
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 0,
    width: 307,
    height: 293
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-343 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.658 146.655C633.946 132.321 621.132 145.914 621.132 145.914L554.765 200.358C553.916 197.213 548.512 188.736 547.355 185.536L639.423 109.907C639.423 109.907 655.201 99.9475 643.453 85.6495 631.741 71.3697 618.909 84.8903 618.909 84.8903L532.299 156C530.564 153.488 525.847 147.414 524.004 144.902L624.403 62.4402C624.403 62.4402 640.182 52.4986 628.434 38.2006 616.722 23.9208 603.908 37.4595 603.908 37.4595L503.454 119.885C501.339 117.553 494.796 110.07 492.609 107.901L586.466 30.7896C586.466 30.7896 602.191 20.8479 590.497 6.54994 578.749-7.72992 565.935 5.79076 565.935 5.79076L466.692 87.2763 458.757 93.8017C458.757 93.8017 476.65 78.6 455.197 96.7481 433.725 114.896 438.605 98.3929 438.605 98.3929L470.379 37.2968C470.379 37.2968 480.193 21.6071 464.523 11.8281 448.817 2.03099 439.021 17.7027 439.021 17.7027L411.223 57.8128C400.144 73.7014 388.74 89.4454 375.546 103.599 338.35 143.673 335.567 206.016 371.226 249.452 410.085 296.811 480.03 303.68 527.383 264.799L534.541 258.906 641.718 170.913C641.628 170.895 657.388 160.953 645.658 146.655Z",
    fill: "#F4900C",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.354 101C450.354 101 497.688 161.066 441.523 236.212 437.654 241.378 427.837 238.858 432.016 232.804 436.578 226.207 482.196 162.19 439.315 104.897 439.297 104.915 446.267 104.063 450.354 101Z",
    fill: "#B55005",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory82);
export default __webpack_public_path__ + "static/media/accessory8-2.108bc3de9738c705cf68ef71c0da8cbb.svg";
export { ForwardRef as ReactComponent };